export function convertMeasurement(value, unit) {
  if (unit === 'in') return value;
  const match = value.trim().match(/^(\d+(?:\.\d+)?)(?:\s*[-–—]\s*(\d+(?:\.\d+)?))?$/);
  if (!match) return value;
  return match.slice(1).filter(Boolean).map((number) => (Number(number) * 2.54).toFixed(1)).join('–');
}

class ParagonSizeChart extends HTMLElement {
  connectedCallback() {
    if (this.dataset.sourceUnit !== 'in') return;
    const controls = this.querySelector('.paragon-size-chart__units');
    if (controls) controls.hidden = false;
    this.addEventListener('click', this.onUnitClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onUnitClick);
  }

  onUnitClick = (event) => {
    const button = event.target.closest('button[data-unit]');
    if (!button || !this.contains(button)) return;
    const unit = button.dataset.unit;
    if (unit !== 'in' && unit !== 'cm') return;
    this.dataset.unit = unit;
    this.querySelectorAll('[data-measurement]').forEach((cell) => {
      const value = convertMeasurement(cell.dataset.measurement, unit);
      const start = cell.querySelector('[data-range-start]');
      const end = cell.querySelector('[data-range-end]');
      const parts = value.split(/[-–—]/).map((part) => part.trim());
      if (start && end && parts.length === 2) {
        start.textContent = parts[0];
        end.textContent = parts[1];
      } else {
        cell.textContent = value;
      }
    });
    this.querySelectorAll('[data-unit-label]').forEach((label) => { label.textContent = unit; });
    this.querySelectorAll('button[data-unit]').forEach((control) => {
      control.setAttribute('aria-pressed', String(control.dataset.unit === unit));
    });
    const status = this.querySelector('[data-unit-status]');
    if (status) status.textContent = status.dataset[unit];
  };
}

if (!customElements.get('paragon-size-chart')) customElements.define('paragon-size-chart', ParagonSizeChart);

document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-size-guide-open]');
  if (!trigger) return;
  const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
  const component = dialog?.closest('dialog-component');
  if (!component) return;
  await customElements.whenDefined('dialog-component');
  component.showDialog();
});
